module.exports = __webpack_public_path__ + "static/bluestripehamper-7b78c39cc78593ecbd18261d35b8af7a.jpeg";